var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quote Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    d: "M27.8076 31.7216V51.6601H8.01685V46.4909C8.01685 38.417 8.60761 32.4109 9.78915 28.4724C11.0692 24.4355 14.3676 18.7247 19.6845 11.3401L28.103 16.0662C23.6722 23.6478 21.1122 28.8662 20.423 31.7216H27.8076ZM54.6876 31.7216V51.6601H34.8968V46.4909C34.8968 38.417 35.4876 32.4109 36.6692 28.4724C37.9492 24.4355 41.2476 18.7247 46.5645 11.3401L54.983 16.0662C50.5522 23.6478 47.9922 28.8662 47.303 31.7216H54.6876Z",
    fill: "#FDE047"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/QuoteIcon.718e70a36d2a03ee7919670fcf783e10.svg";
export { ForwardRef as ReactComponent };